import client from './client'

export function listCategories () {
  return client.get('/category/')
}
